import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { AgentType } from "@/features/agent-inventory/types";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AgentInventoryPage } from "@/features/agent-inventory";
import { AGENT_TYPE } from "@/features/agent-inventory/types";

const AGENT_TYPE_TUPLE = Object.values(AGENT_TYPE) as [AgentType, ...AgentType[]];

/**
 * URL-synced list state: filters, search, sort, and pagination all live in
 * the query string so a filtered/sorted view is shareable and survives a
 * refresh. This is the standard every list route in the app follows.
 */
const agentInventorySearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(20),
  q: z.string().optional().catch(undefined),
  agentType: z.enum(AGENT_TYPE_TUPLE).optional().catch(undefined),
  isOverPermissioned: z.coerce.boolean().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/agent-inventory/")({
  validateSearch: agentInventorySearchSchema,
  component: () => (
    <PermissionGuard module="agent_inventory">
      <AgentInventoryPage />
    </PermissionGuard>
  ),
});
